import { render, staticRenderFns } from "./UsersInvites.vue?vue&type=template&id=789795d9&scoped=true"
import script from "./UsersInvites.vue?vue&type=script&lang=js"
export * from "./UsersInvites.vue?vue&type=script&lang=js"
import style0 from "./UsersInvites.vue?vue&type=style&index=0&id=789795d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789795d9",
  null
  
)

export default component.exports